import { Helmet } from "react-helmet-async";

const SITE = process.env.REACT_APP_BACKEND_URL;

export const absUrl = (path = "") =>
  path.startsWith("http") ? path : `${SITE}${path.startsWith("/") ? "" : "/"}${path}`;

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.label,
    item: it.to ? absUrl(it.to) : undefined,
  })),
});

export default function Seo({
  title, description, path = "", canonical, image, imageAlt,
  keywords, robots = "index, follow, max-image-preview:large, max-snippet:-1",
  jsonLd, type = "website", ogTitle, ogDescription, schemaJson,
}) {
  const url = canonical ? absUrl(canonical) : absUrl(path);
  const ogImage = image
    ? absUrl(image)
    : "https://images.unsplash.com/photo-1494412651409-8963ce7935a7?w=1200&h=630&fit=crop&auto=format&q=72";
  let blocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
  if (schemaJson) {
    try { blocks = [...blocks, JSON.parse(schemaJson)]; } catch { /* ignore invalid custom schema */ }
  }
  const kw = Array.isArray(keywords) ? keywords.join(", ") : keywords;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {kw && <meta name="keywords" content={kw} />}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Ingren Trading LLP" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
